module.exports = __webpack_public_path__ + "img/title_bg.76432aee.png";